<template>
  <div>
    <div
      class="bill-area"
      ref="bill"
      id="printTest"
      v-if="isDom"
      :style="{ width: fontSize(4.5) + 'px', height: fontSize(3) + 'px' }"
    >
      <p
        class="tit"
        :style="{
          fontSize: fontSize(0.26) + 'px',
          lineHeight: fontSize(0.36) + 'px',
        }"
      >
        {{ printRow.name }} {{ printRow.model }}
        <br />
        {{ printRow.sn }}
      </p>
      <div class="code_box" id="qrCode" ref="qrCodeDiv"></div>
    </div>
    <div class="canvas-bill" v-else>
      <img
        :style="{ width: fontSize(4.5) + 'px' }"
        :src="canvasImageUrl"
        alt=""
      />
    </div>
    <!-- <div class="save_btn" @click="htmlToCanvas">保存二维码图片</div> -->
    <el-button size="small" type="primary" v-print="'#printTest'">
      打印
    </el-button>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  props: {
    printRow: {
      type: Object,
      default: {},
    },
  },
  name: "Device",
  data() {
    return {
      isDom: true,
      canvasImageUrl: "",
      ip: window.localStorage.getItem("ip") || "",

      // device_type: 77,
      // id: 42,
      // line_id: 1,
      // model: "CAK6328",
      // name: "数控车床",
      // qrcode: "ZQ-JG-JZ-001",
      // sn: "ZQ-JG-JZ-001",
      // status: "OK",
    };
  },
  created() {
    console.log("this.printRow.id", this.printRow.id);
    this.$nextTick(() => {
      new QRCode(this.$refs.qrCodeDiv, {
        text: "ZQ000" + this.printRow.id.toString(),
        // text: "00094",
        width: 180,
        height: 180,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    });
  },
  mounted() {
    console.log("printRow", this.printRow);
    // setTimeout(() => {
    //   this.htmlToCanvas();
    // }, 1000);
  },
  methods: {
    fontSize(res) {
      let clientWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (!clientWidth) return;
      // let fontSize = 100 * (clientWidth / 1920);
      let fontSize = 100 * 1;
      return res * fontSize;
    },
    htmlToCanvas() {
      html2canvas(this.$refs.bill, {
        background: "#ffffff", // 一定要添加背景颜色，否则出来的图片，背景全部都是透明的
        dpi: 1080,
      }).then((canvas) => {
        let imageUrl = canvas.toDataURL("image/png"); // 将canvas转成base64图片格式
        this.canvasImageUrl = imageUrl;
        // this.isDom = false;
        // this.onPrinter();

        var a = document.createElement("a");
        a.download = "image.png";
        a.href = imageUrl;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.$message.success("保存成功");
      });
    },

    onPrinter() {
      this.$axios
        .printerImgPrint({
          ip: this.ip,
          fileBase64: this.canvasImageUrl,
        })
        .then((res) => {
          if (res.status == 200) {
            if (res.data.status == 200) {
              setTimeout(() => {
                this.$parent.onIn();
              }, 3000);
              // this.$message.success("打印成功");
            } else {
              this.$parent.onIn(2);
              this.$message.error("打印失败");
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.bill-area .info_box .item {
  line-height: 40px;
}
</style>
